/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { RegisterCompanyInput } from './register-company-input';

export class RegisterUserInput {
	company?: RegisterCompanyInput

	customerInfoEffectaGmbh: boolean = false

	email: string = ''

	firstName: string = ''

	lastName: string = ''

	password: string = ''

	privacyPolicy: boolean = false

	subscribedToProductUpdates?: boolean

	termsEffectaGmbh: boolean = false

	termsFinproAG: boolean = false
}